import Add from '@mui/icons-material/Add';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { TEXT_SOFT, TEXT_STRONG } from './FlightCheckParts.js';

interface FlightCheckHeaderProps {
  title?: string | undefined;
  subtitle?: string | undefined;
  onNewBatch: () => void;
}

export function FlightCheckHeader({
  title,
  subtitle,
  onNewBatch,
}: FlightCheckHeaderProps): ReactNode {
  return (
    <Stack
      direction="row"
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '24px',
        flexWrap: 'wrap',
      }}
    >
      <Stack sx={{ gap: '4px', minWidth: 0 }}>
        {title === undefined ? null : (
          <Typography
            component="h1"
            sx={{ fontSize: 28, fontWeight: 500, color: TEXT_STRONG, lineHeight: 'normal' }}
          >
            {title}
          </Typography>
        )}
        {subtitle === undefined ? null : (
          <Typography sx={{ fontSize: 14, color: TEXT_SOFT, lineHeight: 'normal' }}>
            {subtitle}
          </Typography>
        )}
      </Stack>
      <Button
        variant="gradient"
        startIcon={<Add />}
        onClick={onNewBatch}
        sx={{ minHeight: 36, whiteSpace: 'nowrap', flexShrink: 0 }}
      >
        New batch
      </Button>
    </Stack>
  );
}
